export default function () {
  var fired = Array();
  $.fn.isInViewport = function () {
    var isiOffset = 140;
    if ($(this).length) {
      var elementTop = $(this).offset().top + isiOffset;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    } else {
      return false;
    }
  };

  $(window).on('scroll resize ready', function () {
    let elementsToCheck = [
      'campaign',
      'efficacy',
      'safety',
      'dosing',
      'coverage',
      'access',
      'isi-top',
      'about-baxdela-efficacy',
      'about-baxdela-dosing',
      'about-baxdela-microbiological',
      'about-baxdela-safety',
      'about-baxdela-next',
      'efficacy-trial-designs',
      'efficacy-patient-population',
      'efficacy-primary-endpoint',
      'efficacy-secondary-endpoint',
      'efficacy-mrsa',
      'efficacy-outcomes-by-pathogen',
      'safety-adverse-events',
      'safety-discontinuations',
      'safety-safety',
      'dosing-initiate',
      'dosing-convenient',
      'dosing-no-dosage',
      'dosing-fixed-dosage',
      'access-melinta-assist'
    ];

    $.each(elementsToCheck, function (index, item) {
      if (checkElement('#' + item) === true) {
        fireEvent(item);
      }
    });
  });

  $('#back-to-top').on('click', function () {
    fireEvent('scroll-to-top');
  });

  $('#dosing-administration-next').on('click', function () {
    fireEvent('dosing-click-next');
  });

  var fireEvent = function (element) {
    var dataObject = {
      'event': 'HPScroll',
      'hp-scroll-label': element,
    };
    //console.log('Tagging', dataObject);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataObject);
  };

  var checkElement = function (element) {
    if ($(element).isInViewport() && $.inArray(element, fired) === -1) {
      fired.push(element);
      return true;
    }
    return false;
  };
}



// WEBPACK FOOTER //
// ./js/modules/scroll-tagging.js